/* Announcement bar: dismissal for the visit, and turns between messages. */
class C4Announcement extends HTMLElement {
  connectedCallback() {
    const messages = [...this.querySelectorAll('.announcement-message')];
    const close = this.querySelector('[data-announce-close]');
    if (close) {
      close.hidden = false;
      close.addEventListener('click', () => {
        try {
          sessionStorage.setItem('c4-announce', this.dataset.key);
        } catch (error) {
          /* Private modes: it still closes for this page. */
        }
        clearInterval(this.timer);
        this.remove();
        /* The navigation re-reads the bar's height on scroll. */
        dispatchEvent(new Event('scroll'));
      });
    }
    if (messages.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let index = 0;
    const turn = (next) => {
      index = (next + messages.length) % messages.length;
      messages.forEach((message, i) => {
        message.hidden = i !== index;
        message.toggleAttribute('data-turn', i === index);
      });
    };
    this.timer = setInterval(
      () => {
        if (!this.matches(':hover, :focus-within')) turn(index + 1);
      },
      Math.max(4000, Number(this.dataset.interval) || 5000),
    );
    this.addEventListener('shopify:block:select', (event) => {
      clearInterval(this.timer);
      turn(messages.indexOf(event.target));
    });
  }
  disconnectedCallback() {
    clearInterval(this.timer);
  }
}
if (!customElements.get('c4-announcement'))
  customElements.define('c4-announcement', C4Announcement);
